import React, {useState, useEffect} from "react";
import "./style.css";
// import logo from "../../assets/images/logo-orange.png";
import {arrowd_down , exitModal , closeButtonIcon , arrow_down, Phone, whatsApp, location} from "../../assets/svgIcons";
import UseGeneral from "../../hooks/useGeneral";
import {useNavigate , createSearchParams} from "react-router-dom";
import {Axios} from "../../Axios";
import {BASE_URL} from "../../Axios/base_url";
import HeaderIcons from "../header/headerIcons";
import IconWithText from "../iconWithText";
import PopUp from './../popup/index';
import { useSelector } from "react-redux";

const LeftSide = ({open, setOpen , openPopup , setOpenPopup}) => {
  const [openAccordion, setOpenAccordion] = useState(-1);

  /////////////////////////////////////////////////////////////
  const siteData = useSelector((state) => state?.site?.siteData);
  const [mainLocation, setMainLocation] = useState({});
  const [loading, setLoading] = useState(false);

  const getAllUserLocations = () => {
    
    setLoading(true);
    Axios({
      url: BASE_URL + `userlocation/get_user_locations`,
      method: "GET",
    })
      .then((res) => {
        if (res?.status == "success") {
          const theMain = res.result.find((item) => item?.status == "1");
          setMainLocation(theMain);
          setLoading(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  useEffect(() => {
    getAllUserLocations();
  }, []);


  const {language} = UseGeneral();
  const navigate = useNavigate();
  const [headerLoading, setHeaderLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const getCategories = () => {
    setHeaderLoading(true);
    if (
      localStorage.getItem("greenTreesSiteCategories") &&
      localStorage.getItem("greenTreesSiteCategories") != null &&
      localStorage.getItem("greenTreesSiteCategories") != "undefined" &&
      localStorage.getItem("greenTreesSiteCategories") != undefined
    ) {
      try {
        const data = JSON.parse(
          localStorage.getItem("greenTreesSiteCategories")
        );
        setCategories((prev) => data);
      } catch (e) {
        ;
      }
    }
    Axios({
      url: BASE_URL + "categories/get_all",
      method: "GET",
    })
      .then((res) => {
        ;
        if (Array.isArray(res.result)) {
          localStorage.setItem(
            "greenTreesSiteCategories",
            JSON.stringify(res.result)
          );
          setCategories((prev) => res.result);
          ;
        }
        if (res.status == "success") {
        }
      })
      .finally(() => {
        setHeaderLoading(false);
      });
  };
  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div
      className={`side_nav_container ${open ? "open" : ""} ${
        language == "ar" ? "right" : "left"
      }`}
    >
      <div className='side_nave_close'>
        <div className='left' onClick={()=>{
          navigate("/Categories");
          setOpen(false);
        }}>{
          language == "ar" ? "الفئات الرئيسية":"Main Categories"
        }</div>
        <div
          className='right'
          onClick={() => {
            setOpen(false);
          }}
        >
          {closeButtonIcon}
        </div>
      </div>
      
      <div className="my-4 mx-auto" onClick={()=>setOpen(false)}>
        <HeaderIcons/>
      </div>

      
      <div className='side_items'>
        {categories && categories?.length >= 1 && Array.isArray(categories)
          ? categories?.map((cat, index) => {
              return (
                <div key={index}>
                  <div
                    className='side_accordion'
                    onClick={() =>
                      openAccordion == index
                        ? setOpenAccordion()
                        : setOpenAccordion(index)
                    }
                  >
                    <div className="text_image"
                      //  onClick={() => {
                      //   navigate({
                      //     pathname: "/Product",
                      //     search: createSearchParams({
                      //       q: cat.id,
                      //     }).toString(),
                      //   });
                      // }}
                    
                      >
                        <div className="catImage">
                          <img src={cat.image} alt="" />
                        </div>
                      <div className='text side_item'>{language == 'ar'? cat?.title_ar : cat.title_en}</div>
                      <div className='arrow_bottom'>
                        {arrow_down}
                      </div>
                    </div>
                    {/* <div
                      className={`icon ${openAccordion == index ? "open" : ""}`}
                    >
                      {arrowd_down}
                    </div> */}
                  </div>

                  <div
                    className={`side_accordion_items ${
                      openAccordion == index ? "open" : ""
                    }`}
                  >
                    {cat?.subcategories && cat?.subcategories?.length >= 1
                      ? cat?.subcategories?.map((subCat, index) => {
                          return (
                            <div key={index} className='accordion_item bg-none'
                            onClick={() => {
                              navigate({
                                pathname: "/Product",
                                search: createSearchParams({
                                  q: cat.id,
                                  s: subCat.id,
                                }).toString(),
                              });
                              setOpen(false);
                            }}

                            >
                              {language == "ar"
                                ? subCat?.title_ar
                                : subCat?.title_en}
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>
              );
            })
          : null}
      </div>

      {mainLocation?.region_data ? (
        <IconWithText
          icon={location}
          text={
            mainLocation?.region_data
              ? language == "ar"
                ? mainLocation?.region_data?.title_ar
                : mainLocation?.region_data?.title_en
              : language == "ar"
              ? "لا يوجد عنوان"
              : "No location"
          }
        />
      ) : (
        " "
      )}
      <hr />

      <IconWithText
        icon={Phone}
        text={language == "ar" ? "تواصل معنا" : "Contact Us"}
        onClick={() => setOpenPopup(true)
        }
      />
      
    </div>
  );
};

export default LeftSide;
